import axios from 'axios'

var resultsCache = {}

function getSmallestImage(images, minSize) {
	if (images.length === 0) {
		return null
	}
	let smallestImage = images[0]
	for (let image of images) {
		if (image.height > minSize && image.height < smallestImage.height) {
			smallestImage = image
		}
	}
	return smallestImage
}

class Album {
	constructor(album, spotifyApiClient) {
		this.spotifyApiClient = spotifyApiClient
		this.id = album.id + (Math.random() + 1).toString(36)
		this.albumId = album.id
		this.images = album.images
	}
	getSmallestArtUrl(minSize) {
		return getSmallestImage(this.images, minSize).url
	}
	toJSON() {
		return {
			id: this.albumId,
			images: this.images
		}
	}
}

class Playlist {
	constructor(playlist, spotifyApiClient) {
		this.id = playlist.id
		this.name = playlist.name
		this.images = playlist.images
		this.totalTracks = playlist.tracks.total
		this.spotifyApiClient = spotifyApiClient
		this.previewImage = getSmallestImage(this.images, 0)
	}
	getTracks(limit = 50, offset = 0) {
		let cacheKey = `playlistGetTracksId${this.id}Limit${limit}Offset${offset}`
		let getPlaylistTracks = resultsCache[cacheKey] || (resultsCache[cacheKey] = this.spotifyApiClient.getPlaylistTracks(this.id, limit, offset))
		return getPlaylistTracks
			.then(result => {
				return {
					tracks: result.data.items.map(item => item.track),
					next: this.getTracks.bind(this, limit, offset + limit)
				}
			})
	}
	getAlbums(limit = 50, offset = 0) {
		let cacheKey = `playlistGetAlbumsId${this.id}Limit${limit}Offset${offset}`
		let getPlaylistAlbums = resultsCache[cacheKey] || (resultsCache[cacheKey] = this.getTracks(limit, offset))
		return getPlaylistAlbums
			.then(result => {
				let albums = {}
				let tracks = result.tracks
				for (let track of tracks) {
					if (!albums.hasOwnProperty(track.album.id)) {
						albums[track.album.id] = new Album(track.album, this.spotifyApiClient)
					}
				}
				return {
					albums: Object.values(albums),
					next: this.getAlbums.bind(this, limit, offset + limit)
				}
			})
	}
	getPreviewImageUrl() {
		return this.previewImage?.url
	}
}

class Artist {
	spotifyApiClient = null
	constructor(artist, spotifyApiClient) {
		this.spotifyApiClient = spotifyApiClient
		this.id = artist.id
		this.name = artist.name
		this.images = artist.images
		this.previewImage = getSmallestImage(this.images, 0)
	}
	getAlbums(limit = 50, offset = 0) {
		let cacheKey = `aritstGetAlbumsId${this.id}Limit${limit}Offset${offset}`
		let getArtistAlbums = resultsCache[cacheKey] || (resultsCache[cacheKey] = this.spotifyApiClient.getArtistAlbums(this.id, limit, offset))
		return getArtistAlbums
			.then(result => {
				let albums = {}
				for (let album of result.data.items) {
					if (!albums.hasOwnProperty(album.id) && album.album_group != "appears_on") {
						albums[album.id] = new Album(album, this.spotifyApiClient)
					}
				}
				return {
					albums: Object.values(albums),
					next: this.getAlbums.bind(this, limit, offset + limit)
				}
			})
	}
	getPreviewImageUrl() {
		return this.previewImage?.url
	}
}

class SpotifyClient {
	spotifyApiClient = null
	constructor(spotifyApiClient) {
		this.spotifyApiClient = spotifyApiClient
	}
	createAuthUrl() {
		return this.spotifyApiClient.createAuthUrl()
	}
	authenticateUser(code) {
		return this.spotifyApiClient.authenticate(code)
	}
	signOut() {
		this.spotifyApiClient.signOut()
	}
	getUserProfile() {
		return this.spotifyApiClient.getUserProfile()
	}
	createAlbum(albumPrototype) {
		return new Album(albumPrototype, this.spotifyApiClient)
	}
	getPlaylists(limit = 50, offset = 0) {
		let cacheKey = `playlistslimit${limit}offset${offset}`
		let getPlaylistsPromise = resultsCache[cacheKey] || (resultsCache[cacheKey] = this.spotifyApiClient.getUserPlaylists(limit, offset))
		return getPlaylistsPromise
			.then(result => {
				return {
					collection: result.data.items.map(item => new Playlist(item, this.spotifyApiClient)),
					next: this.getPlaylists.bind(this, limit, offset + limit)
				}
			})
	}
	getTopArtists(limit = 50, offset = 0) {
		let cacheKey = `topArtistslimit${limit}offset${offset}`
		let getTopArtistsPromise = resultsCache[cacheKey] || (resultsCache[cacheKey] = this.spotifyApiClient.getTopArtists(limit, offset))
		return getTopArtistsPromise
			.then(result => {
				return {
					collection: result.data.items.map(item => new Artist(item, this.spotifyApiClient)),
					next: this.getTopArtists.bind(this, limit, offset + limit)
				}
			})
	}
}
export default SpotifyClient
